import Theme from "./ts/Theme.ts";

document.addEventListener("DOMContentLoaded", () => {
  const time = new Date();
  const page = document.body;
  const switcher = document.getElementById("theme-switcher");
  const themeSwitcher =
    switcher instanceof HTMLButtonElement ? switcher : undefined;

  const theme = new Theme(time, page, { switcher: themeSwitcher });
  themeSwitcher?.addEventListener("click", (event) => {
    event.preventDefault();
    theme.toggleTheme();
  });
});
